<template>
  <div>
    <div class="solution_con">
      <a-row type="flex" justify="space-between">
        <a-col>
          <div class="prod">
            <div class="title">
              <img src="https://ow-resource.gousii.com/image/solution/Icon_1.png" alt="">
              <h3>私有化解决方案-强化数据保护</h3>
            </div>
            <p>提供专属服务器部署，确保数据完全私有化，强化企业信息安全。适用于追求高度个性化管理的中小型及机构客户，实现数据保护与业务特色化。</p>
          </div>
        </a-col>
        <a-col>
          <div class="prod">
            <div class="title">
              <img src="https://ow-resource.gousii.com/image/solution/Icon_2.png" alt="">
              <h3>全托管服务方案-一站式数据化服务</h3>
            </div>
            <p>涵盖系统全周期服务，包括开发、部署、运维及培训，让企业摆脱技术维护之忧，专注核心业务发展，提升运营效率。</p>
          </div>
        </a-col>
        <a-col>
          <div class="prod">
            <div class="title">
              <img src="https://ow-resource.gousii.com/image/solution/Icon_3.png" alt="">
              <h3>轻定制解决方案-定制化功能扩展</h3>
            </div>
            <p>基于私有化解决方案增加定制服务，根据企业需求可对数据报表、支付系统、智能硬件等模块进行单独定制，功能不受云限制。</p>
          </div>
        </a-col>
        <a-col>
          <div class="prod">
            <div class="title">
              <img src="https://ow-resource.gousii.com/image/solution/Icon_4.png" alt="">
              <h3>全定制解决方案-打造企业专属品牌</h3>
            </div>
            <p>深入剖析企业业务场景，针对企业自身的业务需求痛点，打造专属化的解决方案，打造成企业特有的品牌，助力创新型、集团型企业构建品牌，提升市场竞争力。</p>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "SolutionComponent"
}
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .solution_con {
    width: 94vw !important;
    overflow: hidden;

    .ant-col {

      //margin: 0 auto;
      .prod {
        width: 46vw;
        height: 380px;
      }
    }
  }
}

.solution_con {
  width: 1200px;
  margin: 0 auto;

  .prod {
    background-color: #fff;
    margin-top: 10px;
    width: 278px;
    height: 278px;
    padding: 22px;
    box-sizing: border-box;
    transition: all .3s ease-out;

    &:hover {
      transform: scale(1.16);
      box-shadow: 0 2px 4px 2px rgba(88, 88, 88, .1);

      h3 {
        transform: translateX(-30px);
      }

      img {
        transform: translateX(30px);
      }
    }

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #BFBCC4;
      padding-bottom: 10px;

      h3 {
        color: #0D2A42;
        font-weight: 600;
        margin-bottom: 0;
        transition: all .3s ease-out;
      }

      img {
        transition: all .3s ease-out;
      }
    }

    p {
      color: #666;
      text-align: left;
      font-size: 16px;
      line-height: 26px;
      margin-top: 15px;
      margin-bottom: 0;
    }
  }
}
</style>